export default __webpack_public_path__ + "static/media/done.f0a2986a.svg";